//Comentario necesario para codificación en UTF-8, ver Inc6743
"use strict";

(function() {
	var App = angular.module('pphhApp');
	App.service("uploadService", ["$http", UploadService]);

	function UploadService($http) {
		this.uploadFile = uploadFile;

		function uploadFile(uploadData) {
			var formData = new FormData();
			formData.append("file", uploadData.file);

			var importOptions = {
				rbdId: uploadData.rbdId
			};
			angular.forEach(uploadData.importOptions, function(value, key) {
				importOptions[key] = value;
			});

			formData.append("importOptions",
				new Blob([JSON.stringify(importOptions)],
					{ type: "application/json" })
			);

			var request = {
				method: "POST",
				url: "/pphhNav/import",
				data: formData,
				transformRequest: angular.identity
			};
			request.headers = {};
			request.headers["Content-type"] = undefined;

			return $http(request);
		}
	}

})();
